import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { FadeIn } from "../FadeIn";
import { useT } from "../../lib/i18n";
import { HERO_IMAGE } from "../../lib/images";

export const HeroSection = () => {
  const t = useT();

  return (
    <section
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden grain"
    >
      <motion.div
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.4, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img
          src={HERO_IMAGE}
          alt="Sommet alpin au lever du jour"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-ink" />
      </motion.div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-24 container-x">
        <FadeIn delay={1.2}>
          <div className="eyebrow mb-6 text-bone/85">{t("hero.eyebrow")}</div>
        </FadeIn>
        <FadeIn delay={1.4} y={50}>
          <h1
            data-testid="hero-title"
            className="font-display text-[14vw] md:text-[9vw] leading-[0.92] tracking-[-0.03em] text-bone"
          >
            Romain
            <br />
            <span className="italic font-light text-stone">Bruneau</span>
          </h1>
        </FadeIn>
        <FadeIn delay={1.7}>
          <p className="mt-8 max-w-xl text-bone/80 text-base md:text-lg leading-relaxed">
            {t("hero.tagline")}
            <br />
            <span className="text-bone/60">{t("hero.tagline.sub")}</span>
          </p>
        </FadeIn>
      </div>

      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.2, duration: 1 }}
        className="absolute bottom-8 right-8 z-10 flex items-center gap-3 text-bone/60"
      >
        <span className="text-[10px] tracking-[0.24em] uppercase">Défiler</span>
        <ArrowDown size={14} className="animate-bounce" />
      </motion.div>
    </section>
  );
};
